import { withProps } from 'recompose';
import classnames from 'classnames';

import { defaultFacilityImage } from 'config/facility';
import { Image } from 'components/core/Image';

export const enhance = withProps(({ src, size }) => ({
	src: src
		? `https://images.selfstorage.com/${size || 'small'}-compress/${src}`
		: defaultFacilityImage,
	className: classnames('facility-image', { 'default-facility-image': !src }),
	lazyLoad: true,
}));

export default enhance(Image);
